import TitleBox from "@/components/title.vue";
import { productList, hotProductList } from "@/utils/const.js";
export default {
  name: "Index",
  components: {
    TitleBox
  },
  data() {
    return {
      bannerList: [
        require("@/assets/index/banner1.png"),
        require("@/assets/index/banner2.png"),
        require("@/assets/cooperation-join/banner.png"),
        require("@/assets/about-us/banner.png")
      ],
      tabData: [
        {
          title: "高校打印",
          imgSrc: require("@/assets/index/img1.png"),
          desc:
            "多拉自助云打印终端投放在高校校园内的教学楼、图书馆、寝室楼等人流量比较大的点位。网状分散式布局，满足在校师生多种不同场景的打印需求。解决了传统打印店人多，排队时间长，容易取错文件等问题。",
          path: "/print/college"
        },
        {
          title: "便民打印",
          imgSrc: require("@/assets/index/img2.png"),
          desc:
            "多拉自助云打印终端投放在社区、便利店、共享自习室等场所。满足用户多种不同场景的打印需求，打印价格更透明，文件打印更安全。",
          path: "/print/convenience"
        },
        {
          title: "多拉宝盒",
          imgSrc: require("@/assets/index/img3.png"),
          desc:
            "自主研发设计的一款智能安全打印服务器终端，适配多种市场主流打印机型号。多拉宝盒特点是：尺寸更小，功能更强大，微电子工艺技术，即插即用等诸多优点。",
          path: "/print/box"
        }
      ],
      tabActive: 0
    };
  },
  computed: {
    currentTab() {
      return this.tabData[this.tabActive];
    },
    showHotProductList() {
      return hotProductList.map(item => {
        return productList.find(productItem => productItem.id === item);
      });
    }
  },
  methods: {
    toAboutUsPage() {
      this.$router.push("/about-us");
    },
    tabContentClick() {
      this.$router.push(this.currentTab.path);
    },
    productItemClick(item) {
      this.$router.push("/product/detail?id=" + item.id);
    }
  }
};
